function runUpdate(el, binding, vnode) {
  const vm = vnode.context;
  if (!vm) return;

  const cb = binding.value;
  if (typeof cb !== 'function') {
    return;
  }

  vm.$nextTick(() => {
    if (!el || !el.offsetParent) return;

    const isOverflowing = el.scrollWidth > el.clientWidth;

    cb(isOverflowing);
  });
}

export default {
  inserted(el, binding, vnode) {
    const update = () => runUpdate(el, binding, vnode);
    el.__ellipsisUpdate__ = update;

    update();
    window.addEventListener('resize', update);
  },
  componentUpdated(el) {
    const update = el.__ellipsisUpdate__;
    if (update) update();
  },
  unbind(el) {
    const update = el.__ellipsisUpdate__;
    if (update) {
      window.removeEventListener('resize', update);
      delete el.__ellipsisUpdate__;
    }
  },
};
